"use client";

import { useState, useEffect } from "react";
import Image from "next/image";

interface CountdownImageProps {
  initialImageSrc: string;
  secondImageSrc: string;
  altText: string;
  redirectUrl: string;
  countdownTime?: number;
}

export default function CountdownImage({
  initialImageSrc,
  secondImageSrc,
  altText,
  redirectUrl,
  countdownTime = 5,
}: CountdownImageProps) {
  const [timer, setTimer] = useState(countdownTime);
  const [isClickable, setIsClickable] = useState(false);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setIsClickable(true);
    }
  }, [timer]);

  const handleClick = () => {
    if (isClickable) {
      window.location.href = redirectUrl; // Redirect to the specified URL
    }
  };

  return (
    <div className="text-center">
      <Image
        src={isClickable ? secondImageSrc : initialImageSrc}
        alt={altText}
        width={600}
        height={400}
        unoptimized
        className={`rounded-lg shadow-lg transition-opacity ${
          isClickable ? "cursor-pointer hover:opacity-80" : "opacity-50"
        }`}
        onClick={isClickable ? handleClick : undefined}
      />
    </div>
  );
}
